<div class="w-100 h-100 form">
  <h4 class="text-center">Editar información de Meta Data </h4>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-12">
      <div class="">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Título de Pagina</mat-label>
          <input matInput placeholder="Título de Pagina" [(ngModel)]="this.metaDataInfo.name" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-12">
      <div class="">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Descripción de Pagina</mat-label>
          <textarea matInput #content placeholder="Descripción de Pagina" [maxlength]="maxLength" style="height: 200px" [(ngModel)]="this.metaDataInfo.description" required>
          </textarea>
          <mat-hint align="end">{{content.value?.length || 0}}/{{maxLength}}</mat-hint>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-12">
      <div class="mb-3 max-height">
        <mat-form-field class="example-chip-list" appearance="outline">
          <mat-label>Palabras Clave</mat-label>
          <mat-chip-list #chipList aria-label="Palabras Clave">
            <mat-chip *ngFor="let fruit of metaDataInfo.detail" [selectable]="selectable"
                      [removable]="removable" (removed)="remove(fruit)">
              {{fruit.title}}
              <button (click)="remove(fruit)" mat-icon-button *ngIf="removable">
                <mat-icon color="warn">cancel</mat-icon>
              </button>
            </mat-chip>
            <input placeholder="Nueva Palabra Clave"
                   [matChipInputFor]="chipList"
                   [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                   [matChipInputAddOnBlur]="addOnBlur"
                   (matChipInputTokenEnd)="add($event)">
          </mat-chip-list>
        </mat-form-field>
<!--        <div *ngFor="let link of this.metaDataInfo.detail, index as i">-->
<!--          <div class="d-flex align-items-center">-->
<!--            <h5 class="m-0 font-weight-bold">Link {{i + 1}}</h5>-->
<!--          </div>-->
<!--          <div class="d-flex ">-->
<!--            <mat-form-field appearance="outline" class="w-100 me-4">-->
<!--              <mat-label>Título de Link</mat-label>-->
<!--              <input matInput placeholder="Título de Link" [(ngModel)]="link.title" required>-->
<!--              <mat-error>Este campo es <b>Requerido</b></mat-error>-->
<!--            </mat-form-field>-->
<!--            <button class="mt-2" mat-icon-button >-->
<!--              <mat-icon color="warn">delete</mat-icon>-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="mx-3 d-flex justify-content-center">
      </div>
    </div>
  </div>


  <div class="bottom-button">
    <button class="vs-btn-blue" [disabled]="!validateEmptyFields()" (click)="sendData()">
      Guardar
    </button>
  </div>

</div>
